export default {
  gameLobby: "Game Lobby",
  account: "ID",
  balance: "Balance",
  searchGame: "Search game",
  gameSearch: "Search game",
  myFollowedGames: "Favorite Games",
  allGames: "All",
  like: "My followed games",
  new: "New",
  hot: "Hot",
  reco: "Recommend",
  enterGame: "Enter Game",
  searchText: `About <0>{{searchValue}}</0> search results are as follows:`,
  goToHotGames: "Go to Hot game",
  soEmpty: "Aww~Nothing here",
  cantFindGame: "Cannot find related games",
  noGameCanPlay: "Oops~ There is no game to play",
  cantFindPage: "Page not found",
  sorryPageRunAway: "Sorry, the page does not exist",
  backToHome: "Home",
  authFail: "Invalid Verification",
  goWrong: "Account verification is invalid, please close the page.",
  maintain: "Maintaining",
  annoucement: "Annoucement",
  websiteMaintenance: "Website Maintenance",
  systemMaintain: "System maintenance under process. Please visit later.",
  recentPlayed: "Recently Played",
  send: "Submit",
  payoutRank: "Payout Index",
  playerRank: "Player Rankings",
  rank: "Ranking",
  recommend: "Featured Games",
  idRound: "Player ID/Game No.",
  payout: `Payout Amount <span class="highlight">(¥)</span>`,
  payoutInfo: {
    title: "Updated Every Hour",
    content: [
      `The payout index greater than 0 indicates that the payout of the previous hour is <span class="highlight">higher than</span> the theoretical value.`,
      `The payout index smaller than 0 indicates that the payout of the previous hour is <span class="highlight">lower than</span> the theoretical value.`,
    ],
  },
  playerInfo: {
    title: "Ranking of the past 30 days",
    content: [`Ranking from the most to least based on players' total payout.`],
  },
  newToOld:"New → Old",
  oldToNew:"Old → New",
  favorite: "Favorite",
}
